export default {
	"181c94ea9df20f32666476fdac3b4046": "購買了此商品"
}
